<div class="card shadow-sm mt-2">
  <div class="card-header">
    <h3 class="card-title">Details from Request</h3>
  </div>
  <div class="card-body">
    @if (alertInfo.show) {
      <ngb-alert [type]="alertInfo.type" (closed)="alertInfo.show = false">
        {{ alertInfo.message }}
      </ngb-alert>
    }
    <form [formGroup]="form">
      <div class="row g-3">
        <div class="col-12 mt-2">
          <input-field type="text" [inputFormControl]="getProposalSummaryInput()" label="Summary"
            placeholder="Summary" [readonly]="readonlyProposalDetails" />
        </div>
        <div class="col-12 mt-2">
          <textarea-field label="Description" placeholder="Write description here..."
            [textareaFormControl]="getProposalDescriptionInput()" [height]="200" [readonly]="readonlyProposalDetails"/>
        </div>
        <div class="col-12 mt-2">
          <textarea-field label="Internal note" placeholder="Write notes here..."
            [textareaFormControl]="getProposalNotesInput()"
            [readonly]="readonlyProposalDetails" [height]="150"/>
        </div>
        <div class="col-12 mt-2">
          <textarea-field label="Notes for Client" placeholder="Write notes here..."
            [textareaFormControl]="getProposalNotesForClientInput()"
            [readonly]="readonlyProposalDetails" [height]="150"/>
        </div>
      </div>
    </form>
  </div>
</div>